import { Component } from '@theme/component';

/** @extends {Component<{dialog?: HTMLDialogElement, photo?: HTMLElement}>} */
class EvermoreReviews extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#formatDates();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#formatDates();
  }

  disconnectedCallback() {
    this.refs.dialog?.close();
    super.disconnectedCallback();
  }

  #formatDates() {
    const locale = this.lang || document.documentElement.lang || 'en';
    const relative = new Intl.RelativeTimeFormat(locale, { numeric: 'always' });
    const absolute = new Intl.DateTimeFormat(locale, { dateStyle: 'long' });

    for (const element of this.querySelectorAll('time[datetime]')) {
      const source = element.getAttribute('datetime');
      if (!source || !/^\d{4}-\d{2}-\d{2}$/.test(source)) continue;
      const [year, month, day] = source.split('-').map(Number);
      const date = new Date(year, month - 1, day);
      if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) continue;
      const seconds = (Date.now() - date.getTime()) / 1000;
      if (seconds < 0) continue;
      const periods = [['year', 31536000], ['month', 2592000], ['day', 86400], ['hour', 3600], ['minute', 60]];
      const [unit, duration] = periods.find(([, length]) => seconds >= length) || ['second', 1];
      element.textContent = relative.format(-Math.floor(seconds / duration), unit);
      element.title = absolute.format(date);
    }
  }

  /** @param {MouseEvent} event */
  openImage(event) {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('.em-review__photo') : null;
    const { dialog, photo } = this.refs;
    if (!(link instanceof HTMLAnchorElement) || !dialog || !photo) return;
    const thumbnail = link.querySelector('img');
    if (!(thumbnail instanceof HTMLImageElement)) return;
    event.preventDefault();
    const image = /** @type {HTMLImageElement} */ (thumbnail.cloneNode());
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.loading = 'eager';
    image.src = link.href;
    photo.replaceChildren(image);
    if (!dialog.open) dialog.showModal();
  }

  closeImage() {
    this.refs.dialog?.close();
  }

  /** @param {MouseEvent} event */
  closeOnBackdrop(event) {
    if (event.target !== this.refs.dialog) return;
    const bounds = this.refs.dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.closeImage();
  }
}

if (!customElements.get('evermore-reviews')) customElements.define('evermore-reviews', EvermoreReviews);
